import { ROUTE, ROUTES } from "@/_old/constants/routes";

export const EVENT_CATEGORIES = {
  CUSTOM_OFFICES: "Escritórios Customizados",
  MY_OFFICES: "My Offices",
  MENU: "Menu lateral",
  DASHBOARD: "Dashboard",
  CONTRACTS: "Contratos",
  INSIGHTS: "Utilização",
  VIEW: "View",
  SCROLL: "Scroll",
  PACKAGES: "Pacotes",
  PRIVATE_OFFICES: "Escritórios Privativos",
  PAYMENTS: "Pagamentos",
  ERROR: "Error",
  CHATBOT: "Chatbot",
  COMPANY: "Colaboradores",
  REASONS_OF_USE: "Motivos de Uso",
  WALLET: "Carteira",
};

export const EVENTS = {
  PAGE_MY_OFFICES_VIEW: "page_my_offices_view",
  MY_OFFICES_KPI_VIEW: "my_offices_kpi_view",
  MY_OFFICES_KPI_CLICK: "my_offices_kpi_click",
  MY_OFFICES_AGENT_BANNER_VIEW: "my_offices_agent_banner_view",
  MY_OFFICES_AGENT_BANNER_CLICK: "my_offices_agent_banner_click",
  MY_OFFICES_CARD_CLICK: "my_offices_card_click",
  MY_OFFICES_FILTER_CITY: "my_offices_filter_city",
  MY_OFFICES_FILTER_STATUS: "my_offices_filter_status",
  MY_OFFICES_FILTER_SEARCH: "my_offices_filter_search",
  MY_OFFICES_FILTER_CLEAR: "my_offices_filter_clear",
  MY_OFFICES_VIEW_TOGGLE: "my_offices_view_toggle",
  CUSTOM_OFFICES_SERVICE_ORDERS_BUTTON_CLICK:
    "custom_offices_service_orders_button_click",
  CUSTOM_OFFICES_TICKETS_BUTTON_CLICK: "custom_offices_tickets_button_click",
  CUSTOM_OFFICES_TICKET_BUTTON_CLICK: "custom_offices_ticket_button_click",
  CUSTOM_OFFICES_SERVICE_ORDER_BUTTON_CLICK:
    "custom_offices_service_order_button_click",
  CUSTOM_OFFICES_SERVICE_ORDERS_TAB_CLICK:
    "custom_offices_service_orders_tab_click",
  CUSTOM_OFFICES_TICKETS_TAB_CLICK: "custom_offices_tickets_tab_click",
  CUSTOM_OFFICES_SERVICE_ORDERS_LOAD_MORE_BUTTON_CLICK:
    "custom_offices_service_orders_load_more_button_click",
  PRIVATE_OFFICES_TAB_CLICK: "private_offices_tab_click",
  CUSTOM_OFFICES_TAB_CLICK: "custom_offices_tab_click",
  PAGE_CUSTOM_OFFICES_SERVICE_ORDERS_VIEW:
    "page_custom_offices_service_orders_view",
  PAGE_CUSTOM_OFFICES_TICKETS_VIEW: "page_custom_offices_tickets_view",
  PACKAGES_HEALTH_EXCESS_REVIEW_CLICK: "packages_health_excess_review_click",
  PACKAGES_HEALTH_USAGE_FORECAST_CLICK: "packages_health_usage_forecast_click",
  CHATBOT_CLICK_IA_AGENT: "chatbot_click_ia_agent",
  CLICK_IA_CHAT_NOTIFICATION: "click_ia_chat_notification",
  CHATBOT_SEND_MESSAGE: "chatbot_send_message",
  CHATBOT_SCROLL_VIEW_HISTORY: "chatbot_scroll_view_history",
  LIA_HISTORY_OPEN: "lia_history_open",
  LIA_HISTORY_REOPEN: "lia_history_reopen",
  LIA_HISTORY_DELETE: "lia_history_delete",
  LIA_NEW_CONVERSATION: "lia_new_conversation",
  SCREEN_INSIGHTS_OLD_VS_NEW: "myoffice_ab_screen_insights_old_vs_insights_new",
  NOTIFICATION_UTILIZATION_LINK_OPENED: "notification_utilization_link_opened",
  CLICK_ERROR_REQUEST_BUTTON_LOGIN: "click_error_request_button_login",
  CLICK_ERROR_REQUEST_BUTTON_RELOAD: "click_error_request_button_reload",
  CLICK_ERROR_REQUEST_BUTTON_RESEND_EMAIL:
    "click_error_request_button_resend_email",
  CLICK_ERROR_REQUEST_BUTTON_SUPPORT: "click_error_request_button_support",
  CLICK_INSIGHT_CHECKIN: "click_insight_checkin",
  CLICK_INSIGHT_CONSUMPTION: "click_insight_consumption",
  CLICK_INSIGHT_DAYUSE: "click_insight_dayuse",
  CLICK_INSIGHT_PACKAGE_PAGE: "click_insight_package_page",
  INSIGHT_CONSUMPTION_HIGH_3M_VIEW: "insight_consumption_high_3m_view",
  CLICK_EXCEEDED_CREDITS_CARD_PERCENTAGE:
    "click_exceeded_credits_card_percentage",
  CLICK_EXCEEDED_CREDITS_CARD_MONETARY: "click_exceeded_credits_card_monetary",
  CLICK_EXCEEDED_CREDITS_CARD_MONTH: "click_exceeded_credits_card_month",
  CTA_CLICK_PLAN_REVIEW: "cta_click_plan_review",
  CTA_CLICK_PRIVATE_OFFER: "cta_click_private_offer",
  LEAD_SENT_TO_CLICKUP_HIGH_CONSUMPTION:
    "lead_sent_to_clickup_high_consumption",
  UPGRADE_CONFIRMED: "upgrade_confirmed",
  CLICK_REQUEST_IA_AGENT_ACCESS: "click_request_ia_agent_access",
  CLICK_RESERVATION_REASON: "click_reservation_reason",
  COMPANY_CHANGE_PERMISSIONS_ERROR: "company_change_permissions_error",
  COMPANY_CHANGE_PERMISSIONS: "company_change_permissions",
  COMPANY_PERMISSIONS_CLICK: "company_permissions_click",
  CONTRACTS_FILTER_STATUS: "contracts_filter_status",
  CONTRACTS_SELECT_CONTRACT: "contracts_select_contract",
  RENEWAL_CTA_CLICKED: "renewal_cta_clicked",
  CONTRACT_TAB_FLEXIBLE_CLICK: "contract_tab_flexible_click",
  CONTRACT_TAB_PRIVATE_OFFICE_CLICK: "contract_tab_private_office_click",
  CREDITS_PACKAGES_CLICK: "credits_package_click",
  DASHBOARD_CHANGE_BUDGET: "budget_set",
  DASHBOARD_CLICK_CHAT_IA_AGENT: "dashboard_click_chat_ia_agent",
  DASHBOARD_COLLABORATORS_CARD_MANAGE_MEMBERS_CLICK:
    "dashboard_collaborators_card_manage_members_click",
  DASHBOARD_FILTER_CITY: "dashboard_filter_city",
  DASHBOARD_FILTER_GROUP: "dashboard_filter_group",
  DASHBOARD_FILTER_MEMBERS: "dashboard_filter_members",
  DASHBOARD_FILTER_MONTH: "dashboard_filter_month",
  DASHBOARD_FILTER_NEIGHBORHOOD: "dashboard_filter_neighborhood",
  DASHBOARD_FILTER_RANGE: "dashboard_filter_range",
  DASHBOARD_USE_FILTER_DATE: "dashboard_use_filter_date",
  DASHBOARD_GRAPHIC_DAILY_CLICK: "dashboard_graphic_daily_click_zoho",
  DASHBOARD_MINIMUM_CONSUMPTION: "dashboard_minimum_consumption",
  DASHBOARD_QUALITY_REVIEW_CLICK: "dashboard_quality_review_click",
  DASHBOARD_RESERVATION_DAILY_CLICK: "dashboard_reservation_daily_click_zoho",
  DASHBOARD_SWITCH_CREDITS: "dashboard_switch_credits",
  DASHBOARD_SWITCH_VALUE: "dashboard_switch_value",
  DASHBOARD_RANKINGS_SHEET_VIEW: "dashboard_rankings_sheet_view",
  DASHBOARD_RANKINGS_SPACES_TAB_CLICK: "dashboard_rankings_spaces_tab_click",
  DASHBOARD_RANKINGS_CITIES_TAB_CLICK: "dashboard_rankings_cities_tab_click",
  DASHBOARD_RANKINGS_USERS_TAB_CLICK: "dashboard_rankings_users_tab_click",
  DASHBOARD_RANKINGS_GROUPS_TAB_CLICK: "dashboard_rankings_groups_tab_click",
  DASHBOARD_RANKINGS_LOAD_MORE_CLICK: "dashboard_rankings_load_more_click",
  DASHBOARD_FILTERS_SHEET_VIEW: "dashboard_filters_sheet_view",
  GROUP_DETAILS_CLICK: "group_details_click",
  GROUP_DETAILS_MEMBERS_TAB_CLICK: "group_details_members_tab_click",
  GROUP_DETAILS_SUBSCRIBERS_TAB_CLICK: "group_details_subscribers_tab_click",
  GROUP_EXPORT_CLICK: "group_export_click",
  GROUP_EXPORT_ERROR: "group_export_error",
  GROUP_EXPORT: "group_export",
  GROUP_FILTER_SEARCH: "groups_filter_search",
  GROUPS_TAB_CLICK: "groups_tab_click",
  INSIGHTS_APPLY_FILTERS_CLICK: "apply_filters_click",
  INSIGHTS_DATE_SHORTCUT_SELECT: "date_shortcut_select",
  INSIGHTS_METRIC_DRILLDOWN_OPEN: "metric_drilldown_open",
  INSIGHTS_MEMBER_DETAIL_OPEN: "member_detail_open",
  INSIGHTS_TABLE_SORT: "table_sort",
  INSIGHTS_COLLABORATORS_TAB_CLICK: "collaborators_tab_click",
  INSIGHTS_BOOKINGS_TAB_CLICK: "bookings_tab_click",
  INSIGHTS_EXPORT: "insights_export",
  INSIGHTS_EXPORT_ERROR: "insights_export_error",
  INSIGHTS_FILTER_CLICK: "use_members_filter_click_zoho",
  INSIGHTS_FILTER_RANGE: "use_filter_range",
  INSIGHTS_FILTERS_URL: "insights_filters_url",
  INSIGHTS_RANKING_CITY: "use_ranking_city",
  INSIGHTS_RANKING_GROUPS: "use_ranking_groups",
  INSIGHTS_RANKING_MEMBER: "use_ranking_member",
  INSIGHTS_RANKING_SPACE: "use_ranking_space",
  INSIGHTS_USE_FILTER_CITY: "use_filter_city",
  INSIGHTS_USE_FILTER_GROUP: "use_filter_groups",
  INSIGHTS_USE_FILTER_MEMBERS: "use_filter_members",
  INSIGHTS_USE_FILTER_MONTH_CURRENT_MONTH: "use_filter_current_month",
  INSIGHTS_USE_FILTER_MONTH_LAST_MONTH: "use_filter_last_month",
  INSIGHTS_USE_FILTER_MONTH_LAST_Q: "use_filter_last_q",
  INSIGHTS_USE_FILTER_MONTH_Q: "use_filter_q",
  INSIGHTS_USE_FILTER_MONTH_TODAY: "use_filter_today",
  INSIGHTS_USE_FILTER_MONTH_WEEK: "use_filter_week",
  INSIGHTS_USE_FILTER_MONTH_YEAR: "use_filter_year",
  INSIGHTS_USE_FILTER_MONTH_YESTERDAY: "use_filter_yesterday",
  INSIGHTS_USE_FILTER_NEIGHBORHOOD: "use_filter_neighborhood",
  INSIGHTS_USE_FILTER_SPACE_TYPE: "use_filter_type",
  INSIGHTS_USE_FILTER_SPACE: "use_filter_space",
  INSIGHTS_USE_FILTER_STATUS: "use_filter_status",
  INSIGHTS_USE_RANKING_VIEW: "use_ranking_view",
  MEMBER_ADD: "member_add",
  MEMBER_CHANGE_GROUP_BATCH: "member_change_group_batch",
  MEMBER_CHANGE_GROUP_BATCH_CLICK: "member_change_group_batch_click",
  MEMBER_CHANGE_GROUP_BATCH_ERROR: "member_change_group_batch_error",
  MEMBER_CHANGE_GROUP_ERROR: "member_change_group_error",
  MEMBER_CHANGE_GROUP: "member_change_group",
  MEMBER_CHANGE_PLAN_BATCH: "member_change_plan_batch",
  MEMBER_CHANGE_PLAN_BATCH_ERROR: "member_change_plan_batch_error",
  MEMBER_CHANGE_PLAN_BATCH_CLICK: "member_change_plan_batch_click",
  MEMBER_CHANGE_PLAN_ERROR: "member_change_plan_error",
  MEMBER_CHANGE_PLAN: "member_change_plan",
  MEMBER_CHANGE_ROLE_BATCH: "member_change_role_batch",
  MEMBER_CHANGE_ROLE_BATCH_CLICK: "member_change_role_batch_click",
  MEMBER_CHANGE_ROLE_BATCH_ERROR: "member_change_role_batch_error",
  MEMBER_CHANGE_ROLE_ERROR: "member_change_role_error",
  MEMBER_CHANGE_ROLE: "member_change_role",
  MEMBER_COPY_LINK: "member_copy_link",
  MEMBER_DETAILS_CLICK: "member_details_click",
  MEMBER_CREATE_GROUP_ERROR: "member_create_group_error",
  MEMBER_CREATE_GROUP_CLICK: "member_create_group_click",
  MEMBER_CREATE_GROUP: "member_create_group",
  MEMBER_ERROR_EXPORT_BOOKINGS: "member_error_export_bookings",
  MEMBER_EXPORT_CLICK: "member_export_click",
  MEMBER_EXPORT_ERROR: "member_export_error",
  MEMBER_EXPORT: "member_export",
  MEMBER_FILTER_GROUP: "members_filter_group",
  MEMBER_FILTER_ROLE: "members_filter_role",
  MEMBER_FILTER_SEARCH: "members_filter_search",
  MEMBER_REMOVE_BATCH: "member_remove_batch",
  MEMBER_REMOVE_BATCH_ERROR: "member_remove_batch_error",
  MEMBER_REMOVE_BATCH_CLICK: "member_remove_batch_click",
  MEMBER_REMOVE_CLICK: "member_remove_click",
  MEMBER_REMOVE_ERROR: "member_remove_error",
  MEMBER_REMOVE: "member_remove",
  MEMBER_SEARCH: "member_search",
  MEMBERS_GROUP_CREATE: "members_group_create",
  MEMBERS_IMPORT_ADVANCED: "members_import_advanced",
  MEMBERS_IMPORT_CLICK: "members_import_click",
  MEMBERS_IMPORT_COMPLETE: "members_import_complete",
  MEMBERS_IMPORT_DONWLOAD_INVALID: "members_import_download_invalid",
  MEMBERS_IMPORT_DONWLOAD_REMOVE: "members_import_download_remove",
  MEMBERS_IMPORT_DOWNLOAD_INVALID: "members_import_download_invalid",
  MEMBERS_IMPORT_DOWNLOAD_MODEL: "members_import_download_model",
  MEMBERS_IMPORT_DOWNLOAD_TEMPLATE: "members_import_download_template",
  MEMBERS_IMPORT_EXIT: "members_import_exit",
  MEMBERS_IMPORT_FILE: "members_import_file",
  MEMBERS_IMPORT_INIT: "members_import_init",
  MEMBERS_IMPORT_RETURN: "members_import_return",
  MEMBERS_IMPORT_TABS: "members_import_tabs",
  MEMBERS_IMPORT_TYPE_OPTION: "members_import_type_option",
  MEMBERS_TAB_CLICK: "members_tab_click",
  MEMBERS_INSIGHT_CARD_VIEW: "members_insight_card_view",
  MEMBERS_INSIGHT_CARD_CLICK: "members_insight_card_click",
  MEMBERS_QUICK_FILTER_CLICK: "members_quick_filter_click",
  MENU_COMPANYMEMBERS_CLICK: "menu_companymembers_click",
  MENU_ACTION_CENTER_CLICK: "menu_action_center_click",
  MENU_CONTRACTS_CLICK: "menu_contracts_click",
  MENU_DASHBOARD_CLICK: "menu_dashboard",
  MENU_GROUPS_CLICK: "menu_groups_click",
  MENU_MEMBERS_CLICK: "menu_members_click",
  MENU_PACKAGES_CLICK: "menu_packages_click",
  MENU_PAYMENTS_CLICK: "menu_payments_click",
  MENU_PRIVATE_OFFICES_CLICK: "menu_private_offices_click",
  MENU_REASONS_OF_USE_CLICK: "menu_reasons_of_use_click",
  // PED-13066: clique de saída do WOS para a Gestão de Serviços (ex-Nexus).
  // Nome exato pedido pela task — não renomear para o padrão MENU_*_CLICK.
  REDIRECT_NEXUS_TICKETS_CLICK: "redirect_nexus_tickets_clicked",
  MENU_REPORTS_CLICK: "menu_reports_click",
  MENU_SIDEBAR_COLLAPSE_CLICK: "menu_sidebar_collapse_click",
  MENU_SIDEBAR_EXPAND_CLICK: "menu_sidebar_expand_click",
  MENU_SUBSCRIBERS_CLICK: "menu_subscribers_click",
  MENU_UTILIZATION_CLICK: "menu_utilization_click",
  MENU_VISITSCHEDULES_CLICK: "menu_visitschedules_click",
  PACKAGE_CANCEL_USERS_EXCEPTIONS: "cancel_users_exceptions",
  PACKAGE_CLICK_MODAL_RESTRICTION: "click_modal_restriction",
  PACKAGE_CLICK_SWITCH_RESTRICTION: "click_switch_restriction",
  PACKAGE_FEEDBACK_RESTRICTION: "feedback_restriction",
  PACKAGE_SELECTED_USERS_EXCEPTIONS: "selected_users_exceptions",
  PACKAGE_TAB_RESTRICTION: "tab_restriction",
  PACKAGE_TAB_USERS_EXCEPTIONS: "tab_users_excepcions",
  PACKAGES_ACTION: "packages_action",
  PACKAGES_EXPORT: "packages_export",
  PACKAGE_CLICK_DETAILS: "package_click_details",
  PACKAGE_CLICK_FULL_RANKING: "package_click_full_ranking",
  PACKAGE_CLICK_VIEW_INVOICE: "package_click_view_invoice",
  PAGE_CONTRACTS_SCROLL: "page_contracts_scroll",
  INSIGHTS_EXPORT_REPORT: "insights_export_report",
  INSIGHTS_EXPORT_REPORT_CONFIRM: "insights_export_report_confirm",
  INSIGHTS_EXPORT_REPORT_CLOSE: "insights_export_report_close",
  PAGE_MEMBERS_VIEW: "page_companymembers_view",
  PAGE_SUBSCRIBERS_VIEW: "page_subscribers_view",
  PAGE_GROUPS_VIEW: "page_groups_view",
  PAGE_CONTRACTS_VIEW: "page_contracts_view",
  PAGE_ACTION_CENTER_VIEW: "page_action_center_view",
  PAGE_DASHBOARD_VIEW: "page_dashboard_view",
  PAGE_ERROR_REQUEST_AUTH_ERROR: "page_error_request_auth_error",
  PAGE_ERROR_REQUEST_FORBIDDEN: "page_error_request_forbidden",
  PAGE_ERROR_REQUEST_JS_EXCEPTION: "page_error_request_js_exception",
  PAGE_ERROR_REQUEST_NOT_FOUND: "page_error_request_not_found",
  PAGE_ERROR_REQUEST_SERVER_ERROR: "page_error_request_server_error",
  PAGE_ERROR_REQUEST_USER_NOT_VERIFIED: "page_error_request_user_not_verified",
  PAGE_INSIGHTS_SCROLL: "page_utilization_scroll",
  PAGE_INSIGHTS_VIEW: "page_utilization_view",
  PAGE_MEMBERS_SCROLL: "page_companymembers_scroll",
  SIDEBAR_OFFER_PRIVATEOFFICE: "offer_privateoffice",
  PRIVATE_OFFICES_OFFER_CLICK: "offer_privateoffice",
  PRIVATE_OFFICES_REQUESTS_CLICK: "requests_privateoffice",
  PRIVATE_OFFICES_TAB_OFFICES_CLICK: "po_myoffices",
  PRIVATE_OFFICES_TAB_VISITS_CLICK: "po_visits",
  PRIVATE_OFFICES_SEARCH: "po_search",
  PRIVATE_OFFICES_FILTER_CLEAR_CLICK: "po_clear_filters",
  PRIVATE_OFFICES_FILTER_MONTH_CLICK: "po_filter_month",
  PRIVATE_OFFICES_FILTER_CITY_CLICK: "po_filter_city",
  PRIVATE_OFFICES_FILTER_NEIGHBORHOOD_CLICK: "po_filter_neighborhood",
  PRIVATE_OFFICES_FILTER_COWORKING_CLICK: "po_filter_coworking",
  PRIVATE_OFFICES_FILTER_STATUS_CLICK: "po_filter_reservation_status",
  PRIVATE_OFFICES_SUPPORT_CLICK: "po_support_click",
  PRIVATE_OFFICES_SIMULATOR_OPEN: "po_simulator_open",
  PRIVATE_OFFICES_SIMULATOR_STEP_1: "po_simulator_step_1",
  PRIVATE_OFFICES_SIMULATOR_HELPER_CLICK: "po_simulator_helper_click",
  PRIVATE_OFFICES_COMPARE_CLICK: "po_compare_click",
  PRIVATE_OFFICES_OPPORTUNITY_BANNER_VIEW: "po_opportunity_banner_view",
  PRIVATE_OFFICES_COMPARISON_TEMPLATE_DOWNLOAD:
    "po_comparison_template_download",
  PRIVATE_OFFICES_COMPARISON_REPORT_DOWNLOAD: "po_comparison_report_download",
  PAGE_PACKAGES_DETAILS: "page_packages_detail",
  PAGE_PACKAGES_VIEW: "page_packages_view",
  PAGE_PAYMENTS_VIEW: "page_payments_view",
  PAGE_PRIVATE_OFFICES_VIEW: "page_private_offices",
  PAGE_REPORTS_VIEW: "page_reports_view",
  PAGE_REVIEWS_SCROLL: "page_reviews_scroll",
  PAGE_SCHEDULES_VIEW: "page_visitsschedule_view",
  PAYMENTS_ACCESS_INSIGHTS: "acessar_reservas",
  PAYMENTS_COPY_BARCODE: "copy_code",
  PAYMENTS_DOWNLOAD_INVOICE: "download_fatura",
  PERMISSION_DENIED: "permission_denied",
  REVIEWS_FILTER_CITY: "reviews_filter_city",
  REVIEWS_FILTER_MONTH: "reviews_filter_month",
  REVIEWS_FILTER_RANGE: "reviews_filter_range",
  REVIEWS_FILTER_SPACE_TYPE: "reviews_filter_space_type",
  SUBSCRIBER_EXPORT_CLICK: "subscriber_export_click",
  SUBSCRIBER_EXPORT_ERROR: "subscriber_export_error",
  SUBSCRIBER_EXPORT: "subscriber_export",
  SUBSCRIBER_FILTER_SEARCH: "subscribers_filter_search",
  SUBSCRIBER_REMOVE_CLICK: "subscriber_remove_click",
  SUBSCRIBER_REMOVE_ERROR: "subscriber_remove_error",
  SUBSCRIBER_REMOVE: "subscriber_remove",
  SUBSCRIBER_REMOVE_BATCH_CLICK: "subscriber_remove_batch_click",
  SUBSCRIBER_REMOVE_BATCH_ERROR: "subscriber_remove_batch_error",
  SUBSCRIBER_REMOVE_BATCH: "subscriber_remove_batch",
  SUBSCRIBER_VIEW: "subscriber_view",
  SUBSCRIBERS_TAB_CLICK: "subscribers_tab_click",
  VIEW_PRIVATE_OFFICE: "click_view_pr",
  CLICK_LINK_EXPLORE_SPACES: "click_link_explore_spaces",
  CHATBOT_COPY_MESSAGE_CLICK: "chatbot_copy_message_click",
  CHATBOT_FEEDBACK_LIKE_CLICK: "chatbot_feedback_like_click",
  CHATBOT_FEEDBACK_DISLIKE_CLICK: "chatbot_feedback_dislike_click",
  CHATBOT_SUGGESTION_BOOKINGS_CLICK: "chatbot_suggestion_bookings_click",
  CHATBOT_SUGGESTION_CHECKIN_CLICK: "chatbot_suggestion_checkin_click",
  CHATBOT_SUGGESTION_IMPORT_MEMBERS_CLICK:
    "chatbot_suggestion_import_members_click",
  PAGE_REASONS_OF_USE_VIEW: "page_reasons_of_use_view",
  USAGE_REASON_CREATE_START: "usage_reason_create_start",
  USAGE_REASON_RENAME_START: "usage_reason_rename_start",
  USAGE_REASON_DELETE: "usage_reason_delete",
  USAGE_REASON_TOGGLE_ACTIVE_START: "usage_reason_toggle_active_start",
  USAGE_REASON_TOGGLE_REQUIRED_START: "usage_reason_toggle_required_start",
  USAGE_REASON_CHANGES_SAVE_CONFIRM: "usage_reason_changes_save_confirm",
  USAGE_REASON_CHANGES_DISCARD: "usage_reason_changes_discard",
  CHATBOT_SUGGESTION_REMOVE_MEMBERS_FOR_ME_CLICK:
    "chatbot_suggestion_remove_members_for_me_click",
  CHATBOT_SUGGESTION_CONFIRM_ACTION_CLICK:
    "chatbot_suggestion_confirm_action_click",
  CHATBOT_SUGGESTION_ACCOUNT_ACCESS_CLICK:
    "chatbot_suggestion_account_access_click",
  CHATBOT_SUGGESTION_SPACES_RESERVATIONS_CLICK:
    "chatbot_suggestion_spaces_reservations_click",
  CHATBOT_SUGGESTION_MANAGEMENT_REPORTS_CLICK:
    "chatbot_suggestion_management_reports_click",
  AGENT_ACTION_CLICK: "agent_action_click",
  COMPANY_TYPE_AND_MEMBERS_SIZE: "company_type_and_members_size",

  // Agendamento de relatórios (PED-12415/12416). Os schedule_* são compartilhados
  // entre a tela de Utilização e o chat da Lia — `surface`/`source` distinguem as
  // duas superfícies, e `mode` distingue criação de edição.
  SCHEDULE_CREATE_STARTED: "schedule_create_started",
  SCHEDULE_EDIT_CLICKED: "schedule_edit_clicked",
  SCHEDULE_REPORT_SELECTED: "schedule_report_selected",
  SCHEDULE_FREQUENCY_SELECTED: "schedule_frequency_selected",
  SCHEDULE_CHANNEL_SELECTED: "schedule_channel_selected",
  SCHEDULE_WHATSAPP_CONFIRM_VIEWED: "schedule_whatsapp_confirm_viewed",
  SCHEDULE_WHATSAPP_NUMBER_UPDATED: "schedule_whatsapp_number_updated",
  SCHEDULE_SAVED: "schedule_saved",
  SCHEDULE_SAVE_FAILED: "schedule_save_failed",
  SCHEDULE_UPDATED: "schedule_updated",
  SCHEDULE_PAUSED: "schedule_paused",
  SCHEDULE_DELETE_CLICKED: "schedule_delete_clicked",
  SCHEDULE_DELETE_CONFIRMED: "schedule_delete_confirmed",
  AGENT_SUGGESTION_CLICK: "agent_suggestion_click",
  AGENT_ACTION_CARD_VIEW: "agent_action_card_view",

  // Ações "faça por mim" do agente (PED-12416): botões que disparam uma ação
  // assistida por IA dentro do fluxo, e não uma pergunta ao chat.
  AGENT_ACTION_DO_FOR_ME_AUTOCORRECT_MEMBER_IMPORT:
    "agent_action_do_for_me_autocorrect_member_import",
  AGENT_ACTION_DO_FOR_ME_IMPROVE_REPORT_DESCRIPTION:
    "agent_action_do_for_me_improve_report_description",
  AGENT_ACTION_DO_FOR_ME_ADD_EMPLOYEE: "agent_action_do_for_me_add_employee",

  // Modal de promoção do agendamento, exibida após exportar na tela de Utilização.
  INSIGHTS_SCHEDULE_PROMO_CLICK: "insights_schedule_promo_click",
  INSIGHTS_SCHEDULE_PROMO_CLOSE: "insights_schedule_promo_close",

  // Carteira (PED-13444/PED-13539), todos sob o prefixo `wallet_charge*`.
  WALLET_CHARGE_DETAIL_VIEW_CLICKED: "wallet_charge_detail_view_clicked",
  WALLET_CHARGE_INVOICE_DOWNLOAD_CLICKED:
    "wallet_charge_invoice_download_clicked",
  WALLET_CHARGE_USAGE_REPORT_VIEW_CLICKED:
    "wallet_charge_usage_report_view_clicked",
  WALLET_CHARGES_TAB_CLICK: "wallet_charges_tab_click",
};

export const EVENT_BY_ROUTE: { [key in ROUTE]?: string } = {
  [ROUTES.MEMBERS]: EVENTS.MENU_MEMBERS_CLICK,
  [ROUTES.MEMBERS_SUBSCRIBERS]: EVENTS.MENU_SUBSCRIBERS_CLICK,
  [ROUTES.MEMBERS_GROUPS]: EVENTS.MENU_GROUPS_CLICK,
  [ROUTES.CONTRACTS]: EVENTS.MENU_CONTRACTS_CLICK,
  [ROUTES.DASHBOARD]: EVENTS.MENU_DASHBOARD_CLICK,
  [ROUTES.INSIGHTS]: EVENTS.MENU_UTILIZATION_CLICK,
  [ROUTES.PRIVATE_OFFICES]: EVENTS.MENU_PRIVATE_OFFICES_CLICK,
  [ROUTES.SCHEDULINGS]: EVENTS.MENU_VISITSCHEDULES_CLICK,
  [ROUTES.MEMBERS_IMPORT]: EVENTS.MEMBERS_IMPORT_INIT,
};

export type EVENT_FILTER =
  | "FILTER_RANGE"
  | "FILTER_CITY"
  | "TODAY"
  | "YESTERDAY"
  | "CURRENT_WEEK"
  | "CURRENT_MONTH"
  | "LAST_MONTH"
  | "CURRENT_QUARTER"
  | "LAST_QUARTER"
  | "CURRENT_YEAR"
  | "FILTER_GROUP"
  | "FILTER_BOOKING_TYPE"
  | "FILTER_SEARCH"
  | "FILTER_STATUS"
  | "FILTER_NEIGHBORHOOD"
  | "FILTER_MEMBERS"
  | "FILTER_SPACE"
  | "FILTER_ROLE"
  | "FILTER_OPERATIONS"
  | "FILTER_TYPE"
  | "FILTER_PRIORITIES";

export const EVENTS_FILTER_BY_PAGE: {
  [key in ROUTE]?: { [key in EVENT_FILTER]?: string };
} = {
  [ROUTES.DASHBOARD]: {
    FILTER_RANGE: EVENTS.DASHBOARD_FILTER_RANGE,
    USE_FILTER_TODAY: EVENTS.INSIGHTS_USE_FILTER_MONTH_TODAY,
    USE_FILTER_YESTERDAY: EVENTS.INSIGHTS_USE_FILTER_MONTH_YESTERDAY,
    USE_FILTER_WEEK: EVENTS.INSIGHTS_USE_FILTER_MONTH_WEEK,
    USE_FILTER_CURRENT_MONTH: EVENTS.INSIGHTS_USE_FILTER_MONTH_CURRENT_MONTH,
    USE_FILTER_LAST_MONTH: EVENTS.INSIGHTS_USE_FILTER_MONTH_LAST_MONTH,
    USE_FILTER_Q: EVENTS.INSIGHTS_USE_FILTER_MONTH_Q,
    USE_FILTER_LAST_Q: EVENTS.INSIGHTS_USE_FILTER_MONTH_LAST_Q,
    USE_FILTER_YEAR: EVENTS.INSIGHTS_USE_FILTER_MONTH_YEAR,
    FILTER_CITY: EVENTS.DASHBOARD_FILTER_CITY,
    FILTER_MONTH: EVENTS.DASHBOARD_FILTER_MONTH,
    FILTER_GROUP: EVENTS.DASHBOARD_FILTER_GROUP,
    FILTER_NEIGHBORHOOD: EVENTS.DASHBOARD_FILTER_NEIGHBORHOOD,
    FILTER_MEMBERS: EVENTS.DASHBOARD_FILTER_MEMBERS,
  },
  [ROUTES.REVIEWS]: {
    FILTER_BOOKING_TYPE: EVENTS.REVIEWS_FILTER_SPACE_TYPE,
    FILTER_CITY: EVENTS.REVIEWS_FILTER_CITY,
    FILTER_RANGE: EVENTS.REVIEWS_FILTER_RANGE,
    FILTER_MONTH: EVENTS.REVIEWS_FILTER_MONTH,
  },
  [ROUTES.COMPANY.slice(0, -2) + ROUTES.MEMBERS]: {
    FILTER_SEARCH: EVENTS.MEMBER_FILTER_SEARCH,
    FILTER_GROUP: EVENTS.MEMBER_FILTER_GROUP,
    FILTER_ROLE: EVENTS.MEMBER_FILTER_ROLE,
  },
  [ROUTES.COMPANY.slice(0, -2) + ROUTES.MEMBERS_SUBSCRIBERS]: {
    FILTER_SEARCH: EVENTS.SUBSCRIBER_FILTER_SEARCH,
    FILTER_GROUP: EVENTS.MEMBER_FILTER_GROUP,
    FILTER_ROLE: EVENTS.MEMBER_FILTER_ROLE,
  },
  [ROUTES.COMPANY.slice(0, -2) + ROUTES.MEMBERS_GROUPS]: {
    FILTER_SEARCH: EVENTS.GROUP_FILTER_SEARCH,
    FILTER_GROUP: EVENTS.MEMBER_FILTER_GROUP,
  },
  [ROUTES.CONTRACTS]: {
    FILTER_STATUS: EVENTS.CONTRACTS_FILTER_STATUS,
  },
  [ROUTES.INSIGHTS]: {
    FILTER_RANGE: EVENTS.INSIGHTS_FILTER_RANGE,
    USE_FILTER_TODAY: EVENTS.INSIGHTS_USE_FILTER_MONTH_TODAY,
    USE_FILTER_YESTERDAY: EVENTS.INSIGHTS_USE_FILTER_MONTH_YESTERDAY,
    USE_FILTER_WEEK: EVENTS.INSIGHTS_USE_FILTER_MONTH_WEEK,
    USE_FILTER_CURRENT_MONTH: EVENTS.INSIGHTS_USE_FILTER_MONTH_CURRENT_MONTH,
    USE_FILTER_LAST_MONTH: EVENTS.INSIGHTS_USE_FILTER_MONTH_LAST_MONTH,
    USE_FILTER_Q: EVENTS.INSIGHTS_USE_FILTER_MONTH_Q,
    USE_FILTER_LAST_Q: EVENTS.INSIGHTS_USE_FILTER_MONTH_LAST_Q,
    USE_FILTER_YEAR: EVENTS.INSIGHTS_USE_FILTER_MONTH_YEAR,
    FILTER_BOOKING_TYPE: EVENTS.INSIGHTS_USE_FILTER_SPACE_TYPE,
    FILTER_GROUP: EVENTS.INSIGHTS_USE_FILTER_GROUP,
    FILTER_NEIGHBORHOOD: EVENTS.INSIGHTS_USE_FILTER_NEIGHBORHOOD,
    FILTER_MEMBERS: EVENTS.INSIGHTS_USE_FILTER_MEMBERS,
    FILTER_SPACE: EVENTS.INSIGHTS_USE_FILTER_SPACE,
    FILTER_STATUS: EVENTS.INSIGHTS_USE_FILTER_STATUS,
    FILTER_CITY: EVENTS.INSIGHTS_USE_FILTER_CITY,
  },
  [ROUTES.PACKAGES]: {
    CLICK_MODAL_RESTRICTION: EVENTS.PACKAGE_CLICK_MODAL_RESTRICTION,
    TAB_RESTRICTION: EVENTS.PACKAGE_TAB_RESTRICTION,
    CLICK_SWITCH_RESTRICTION: EVENTS.PACKAGE_CLICK_SWITCH_RESTRICTION,
    CANCEL_USERS_EXCEPTIONS: EVENTS.PACKAGE_CANCEL_USERS_EXCEPTIONS,
    SELECTED_USERS_EXCEPTIONS: EVENTS.PACKAGE_SELECTED_USERS_EXCEPTIONS,
    FEEDBACK_RESTRICTION: EVENTS.PACKAGE_FEEDBACK_RESTRICTION,
    TAB_USERS_EXCEPTIONS: EVENTS.PACKAGE_TAB_USERS_EXCEPTIONS,
  },
};
